/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Backoffice API Gateway
 * OpenAPI spec version: 1.0.0
 */
import type { MandrillSearchResult, SearchMandrillRequest } from "../model"

import { backofficeRequest } from "../../client"

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

/**
 * @summary Search Mandrill email communications by query and date range
 */
export const searchMandrill = (
  searchMandrillRequest: SearchMandrillRequest,
  options?: SecondParameter<typeof backofficeRequest<MandrillSearchResult[]>>,
) => {
  return backofficeRequest<MandrillSearchResult[]>(
    {
      url: `/communication/mandrill/search`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: searchMandrillRequest,
    },
    options,
  )
}
export type SearchMandrillResult = NonNullable<
  Awaited<ReturnType<typeof searchMandrill>>
>
